import { sendHTTPRequest } from '@/util/http'
import { goalbookUrls } from '@/util/links'
import type { AssessmentItem } from './assessment_item_types'

export async function getAssessmentItem(itemId: string): Promise<AssessmentItem> {
  try {
    const response = await sendHTTPRequest({
      url: `${goalbookUrls.pathwaysApi}/items/${itemId}`,
      method: 'GET',
      urlParams: { denormalized: '1' },
      includeCredentials: true
    })
    return await response.json() as AssessmentItem
  } catch (e) {
    throw new Error('Error getting assessment item', { cause: e })
  }
}
